import { baseRoute } from '../../constants/routes';
export const TENANTS_ROUTE = baseRoute + '/admin/tenants';
export const GET_TENANTS_LIST = 'GET_TENANTS_LIST';
export const GET_TENANTS_LIST_SUCCESS = 'GET_TENANTS_LIST_SUCCESS';

